@if (!hideHeader()) {
  @if (page?.externalEmbedding) {
  <div class="pt-3 pb-4">
    <ng-container *ngTemplateOutlet="headerContent"></ng-container>
  </div>
  } @else {
  <div class="content__boxed content__header overlapping">
    <div class="content__wrap pt-3 pb-4">
      <ng-container *ngTemplateOutlet="headerContent"></ng-container>
    </div>
  </div>
  }
}

<ng-template #headerContent>
  @if (page?.breadcrumbs) {
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      @for(item of page?.breadcrumbs; track $index; let last = $last) {
      <li class="breadcrumb-item" [ngClass]="last ? 'breadcrumb-item active' : 'breadcrumb-item'">
        @if (!last) {
        <a>{{item}}</a>
        } @else {
        {{item}}
        }
      </li>
      }
    </ol>
  </nav>
  }
  @if(page?.title) {
  <h1 class="page-title mb-2" [ngClass]="page?.breadcrumbs ? 'mt-4' : ''">{{page?.title}}</h1>
  }
  @if (page?.lead) {
  <p class="lead">
    {{page?.lead}}
  </p>
  }
</ng-template>

<div [ngClass]="page?.externalEmbedding ? '' : 'content__boxed'">
  <div [ngClass]="page?.externalEmbedding ? '' : 'content__wrap'">
    @if(page?.infoTitle || page?.infoMessage || page?.infoContent?.length) {
    <div class="card mb-4">
      <div class="card-body">
        <h5 class="card-title">{{page?.infoTitle}}</h5>
        <p>{{page?.infoMessage}}</p>
        @for (element of page?.infoContent; track $index) {
        <ng-container *ngComponentOutlet="element.componentType; inputs: { element: element }"></ng-container>
        }
      </div>
    </div>
    }
    <article class="d-md-flex gap-4">
      <div class="flex-fill">
        @for (element of page?.sections; track $index) {
        <ng-container *ngComponentOutlet="element.componentType; inputs: { element: element }"></ng-container>
        }
      </div>
      @if(page?.tipTitle || page?.tipMessage || page?.tipContent?.length) {
      <div class="w-md-160px w-xl-250px flex-shrink-0">
        <div class="card position-sticky" style="top: 1rem">
          <div class="card-body">
            <h5>{{page?.tipTitle}}</h5>
            <p>{{page?.tipMessage}}</p>
            @for (element of page?.tipContent; track $index) {
            <ng-container *ngComponentOutlet="element.componentType; inputs: { element: element }"></ng-container>
            }
          </div>
        </div>
      </div>
      }
    </article>
  </div>
</div>